export enum ResponseType {
  erreur,
  info,
  succes = 2,
  warning = 3
}

export class ResponseCardModel {
  type: ResponseType;
  message: string;
  idObject: number;
  isDonneurOrdreEntreprise: boolean;
  idDonneurOrdre: number;
}
